module.exports = __webpack_public_path__ + "media/images/logo-d8fb946106e971f65d859e3184a73f2d.svg";